export class ConventionCenter {

    public id: string = "0";
    public name: string;
    public city: string;
    public state: string;
    public address: string;
    public rooms: any[] = []
    
    public deleted: boolean=false;

    constructor() {}
}